"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTypeaheadCategoryArray = exports.isTypeaheadCategory = exports.isValidTypeaheadCategoryV8 = exports.isValidTypeaheadCategory = exports.ValidTypeaheadCategories = void 0;
const V8Config_1 = require("./V8Config");
const Util_1 = require("./Util");
// https://stg-searchservice-v8.kyruus.com/docs/#!/typeahead/typeahead
// https://kyruus.jira.com/wiki/spaces/AHC/pages/2169144221/Search+API+v8+vs.+v9#Categories-Differences
exports.ValidTypeaheadCategories = [
    'clinical_keywords',
    'conditions_symptoms',
    'location_name',
    'marketable_locations',
    'marketable_location_type',
    'marketable_location_services',
    'network_affiliation',
    'practice_group',
    'primary_care',
    'provider_name',
    'specialties',
    'treatments_procedures'
];
const isValidTypeaheadCategory = (category) => exports.ValidTypeaheadCategories.includes(category);
exports.isValidTypeaheadCategory = isValidTypeaheadCategory;
const isValidTypeaheadCategoryV8 = (category) => {
    return V8Config_1.ValidV8TypeaheadCategories.includes(category);
};
exports.isValidTypeaheadCategoryV8 = isValidTypeaheadCategoryV8;
const isTypeaheadCategory = (dict) => {
    return Boolean(((0, exports.isValidTypeaheadCategory)(dict.category) ||
        (0, exports.isValidTypeaheadCategoryV8)(dict.category)) &&
        (0, Util_1.isString)(dict.display_text));
};
exports.isTypeaheadCategory = isTypeaheadCategory;
exports.isTypeaheadCategoryArray = (0, Util_1.predicateArrayOn)(exports.isTypeaheadCategory);
//# sourceMappingURL=TypeaheadCategory.js.map